<template>
  <div>
    <!-- 顶部开始 -->
    <div class="container">
      <div class="logo" style="float:left">
         <img style="width:100px;height:35px;float:left;margin:5px" src="../../static/other/vfs-global-logo.svg" />
        <a target="_blank" style="color:#0b305c" >美签费用记录系统</a>
      </div>

      <ul class="layui-nav right" lay-filter="">
        <li class="layui-nav-item" style="color:#0b305c">
          当前用户：<strong>{{ user }}</strong>
        
        </li>
        <li class="layui-nav-item to-index">
          <a href="#"  onclick="xadmin.open('修改密码','/xgmm','700','300')"><p style="font-size:13px;color:red;text-decoration:underline">修改密码</p></a>
        </li>
        <li class="layui-nav-item to-index">
          <a href="/admin" @click="exit"><p style="font-size:13px;color:red;text-decoration:underline">退出系统</p></a>
        </li>
      </ul>
    </div>
    <!-- 顶部结束 -->
    <!-- 中部开始 -->
    <!-- 左侧菜单开始 -->
    <div class="left-nav">
      <div style="float: right">
        <i title="展开左侧栏" class="iconfont zkzcl" style="cursor: pointer"
          >&#xe790;</i
        >
      </div>
      <div id="side-nav" style="height: 100%; overflow-y: auto">
        <ul id="nav">
          <!-- 循环一级父菜单 -->
          <li v-for="(item, index) in menu_array.filter((x) => x.pid == null)">
            <a href="javascript:;">
              <i v-bind:class="item.icon"></i>
              <cite>{{ item.cd_mc }}</cite>
              <i class="fa fa-angle-left" style="float: right"></i>
            </a>
            <ul class="sub-menu">
              <!-- 循环二级父菜单 -->
              <li v-for="(citem, cindex) in menu_array.filter((x) => x.pid == item.id && x.cd_url == null)">
                <a href="javascript:;">
                  <i v-bind:class="citem.icon"></i>
                  <cite>{{ citem.cd_mc }}</cite>
                  <i class="fa fa-angle-left" style="float: right"></i>
                </a>
                
               

               
                <ul class="sub-menu">
                   <!-- 循环三级父菜单 -->
                   <li v-for="(ccitem, ccindex) in menu_array.filter((x) => x.pid == citem.id && x.cd_url == null)">
                      <a href="javascript:;">
                        <i v-bind:class="ccitem.icon"></i>
                        <cite>{{ ccitem.cd_mc }}</cite>
                        <i class="fa fa-angle-left" style="float: right"></i>
                      </a>

                      <!-- 循环四级子菜单 -->
                      <ul class="sub-menu">
                        <li v-for="(cccitem, cccindex) in menu_array.filter((x) => x.pid == ccitem.id)">
                          <a @click="add_tab(cccitem.id, cccitem.cd_mc, cccitem.cd_url,cccitem.tb_mc,cccitem.cx_type)">
                             <i ></i> <!--class="fa fa-angle-right" -->
                            <cite>{{ cccitem.cd_mc }}</cite>
                          </a>
                        </li>
                      </ul>
                  </li>
                   <!-- 循环三级子菜单 -->
                  <li v-for="(ccitem, ccindex) in menu_array.filter((x) => x.pid == citem.id && x.cd_url != null)">
                    <a @click="add_tab(ccitem.id, ccitem.cd_mc, ccitem.cd_url,ccitem.tb_mc,ccitem.cx_type)">
                      <i ></i>
                      <!-- class="fa fa-angle-right" -->
                      <cite>{{ ccitem.cd_mc }}</cite>
                    </a>
                  </li>
                </ul>
              </li>
              <!-- 循环二级子菜单 -->
              <li v-for="(citem, cindex) in menu_array.filter((x) => x.pid == item.id && x.cd_url != null)">
                <a @click="add_tab(citem.id, citem.cd_mc, citem.cd_url,citem.tb_mc,citem.cx_type)">
                  <i ></i>
                  <!-- class="fa fa-angle-right" -->
                  <cite>{{ citem.cd_mc }}</cite>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="x-slide_left"></div> -->
    <!-- 左侧菜单结束 -->
    <!-- 右侧主体开始 -->
    <div class="page-content">
      <div class="layui-tab tab" lay-filter="xbs_tab" lay-allowclose="false">
        <ul class="layui-tab-title">
          <li class="home"></li>
          <!-- <i class="layui-icon">&#xe68e;</i>我的桌面 -->
        </ul>
        <div
          class="layui-unselect layui-form-select layui-form-selected"
          id="tab_right"
        >
          <dl>
            <dd data-type="this">关闭当前</dd>
            <dd data-type="other">关闭其它</dd>
            <dd data-type="all">关闭全部</dd>
          </dl>
        </div>
        <div class="layui-tab-content">
          <div class="layui-tab-item layui-show">
            <iframe
              src="/welcome"
              frameborder="0"
              scrolling="yes"
              class="x-iframe"
            ></iframe>
          </div>
        </div>
        <div id="tab_show"></div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../../static/css/font.css";
@import "../../static/css/xadmin.css";
</style>

<script>
export default {
  data() {
    return {
      user: "",
      menu_array: [],
    };
  },
  created() {
    
    this.user = sessionStorage.getItem("username");
    this.$axios.get("api/system/qxgl/get-menu-list-person").then(res => {
      if (res.data.code == 200) {
        this.menu_array = res.data.data;
        // console.log(this.menu_array)
        var test = ""
        res.data.data.forEach(element => {
          test += element.cd_url+','
        });
        localStorage.setItem("test", test);
        // console.log("结果："+localStorage.getItem("test"))
      }

    });
  },
  methods: {
    add_tab(cdid, cdmc, url,tbmc,cxtype) {
      xadmin.add_tab(cdmc, url+"?cdmc="+cdmc+"&tbmc="+tbmc+"&cxtype="+cxtype);
    },
    exit(){
      localStorage.removeItem('islogin')
      localStorage.removeItem('token')
      localStorage.removeItem('test')
      this.$axios.get("api/system/auth/exit").then(res => {
      })
    }
  }
};
</script>


 


// WEBPACK FOOTER //
// src/view/homepage.vue